import { useRef } from 'react';
import getConfig from 'next/config';
import PQueue from 'p-queue';

const { publicRuntimeConfig } = getConfig();

const { BULK_BIDDING_CONCURRENCY, BULK_BIDDING_INTERVAL_IN_MS, BULK_BIDDING_REQUESTS_PER_INTERVAL } =
	publicRuntimeConfig;

export const CONCURRENCY = Number(BULK_BIDDING_CONCURRENCY ?? 3);
export const INTERVAL_IN_MS = Number(BULK_BIDDING_INTERVAL_IN_MS ?? 3000);
export const REQUESTS_PER_INTERVAL = Number(BULK_BIDDING_REQUESTS_PER_INTERVAL ?? 10);

const rateLimitingQueue = new PQueue({
	carryoverConcurrencyCount: true,
	concurrency: CONCURRENCY,
	interval: INTERVAL_IN_MS,
	intervalCap: REQUESTS_PER_INTERVAL,
});

export const useRateLimitedQueue = () => {
	const queueRef = useRef(rateLimitingQueue);
	return queueRef.current;
};
